// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"4DKFW":[function(require,module,exports) {
// cookies.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Function to get the workout streak from the cookie
parcelHelpers.export(exports, "getWorkoutStreak", ()=>getWorkoutStreak);
parcelHelpers.export(exports, "checkWorkoutCompletion", ()=>checkWorkoutCompletion);
parcelHelpers.export(exports, "markWorkoutAsCompleted", ()=>markWorkoutAsCompleted);
parcelHelpers.export(exports, "setHideIntroOverlay", ()=>setHideIntroOverlay);
parcelHelpers.export(exports, "getHideIntroOverlay", ()=>getHideIntroOverlay);
function setCookie(name, value, expires) {
    let expiresString = "";
    if (expires) expiresString = "; expires=" + expires.toUTCString();
    document.cookie = name + "=" + (value || "") + expiresString + "; path=/";
}
// Function to get a cookie by name
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
// Function to check if a cookie exists and its value
function checkCookie(name) {
    const cookieValue = getCookie(name);
    return cookieValue !== null;
}
// Function to delete a cookie by name
function deleteCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
}
function setCookieToExpireAtMidnight(name, value) {
    const now = new Date();
    const expires = new Date();
    expires.setHours(24, 0, 0, 0);
    console.log(expires);
    setCookie(name, value, expires);
}
function getWorkoutStreak() {
    const streak = getCookie("workoutStreak");
    return streak ? parseInt(streak, 10) : 0;
}
// Function to set or update the workout streak
function updateWorkoutStreak() {
    let streak = getWorkoutStreak();
    const expires = new Date();
    expires.setDate(expires.getDate() + 1);
    expires.setHours(24, 0, 0, 0);
    streak = streak > 0 ? streak + 1 : 1;
    setCookie("workoutStreak", streak, expires);
}
function checkWorkoutCompletion() {
    return getCookie("workoutCompleted") === "true";
}
function markWorkoutAsCompleted() {
    setCookieToExpireAtMidnight("workoutCompleted", "true");
    updateWorkoutStreak();
}
function setHideIntroOverlay() {
    const date = new Date();
    date.setDate(date.getDate() + 30);
    setCookie("hideIntroOverlay", "true", date);
}
function getHideIntroOverlay() {
    return getCookie("hideIntroOverlay") === "true";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["4DKFW"], "4DKFW", "parcelRequire3809")

//# sourceMappingURL=index.954923be.js.map
